"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseMPErrorToJSON = exports.ResponseMPErrorFromJSONTyped = exports.ResponseMPErrorFromJSON = exports.instanceOfResponseMPError = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ResponseMPError interface.
 */
function instanceOfResponseMPError(value) {
    var isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "statusCode" in value;
    isInstance = isInstance && "error" in value;
    return isInstance;
}
exports.instanceOfResponseMPError = instanceOfResponseMPError;
function ResponseMPErrorFromJSON(json) {
    return ResponseMPErrorFromJSONTyped(json, false);
}
exports.ResponseMPErrorFromJSON = ResponseMPErrorFromJSON;
function ResponseMPErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'message': json['message'],
        'statusCode': json['statusCode'],
        'error': json['error'],
        'upStreamService': !(0, runtime_1.exists)(json, 'upStreamService') ? undefined : json['upStreamService'],
    };
}
exports.ResponseMPErrorFromJSONTyped = ResponseMPErrorFromJSONTyped;
function ResponseMPErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'message': value.message,
        'statusCode': value.statusCode,
        'error': value.error,
        'upStreamService': value.upStreamService,
    };
}
exports.ResponseMPErrorToJSON = ResponseMPErrorToJSON;
